import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useBranding } from "../../contexts/branding";
import { useQueryParam } from "../../hooks/use-query-string";
import "./styles.scss"; // import your styles
import i18n from "../../utils/i18n";

function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

const flagMap: Record<string, string> = {
    en: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
    es: "https://upload.wikimedia.org/wikipedia/en/9/9a/Flag_of_Spain.svg",
};

function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const check = () => setIsMobile(window.innerWidth <= 600);
        check();
        window.addEventListener("resize", check);
        return () => window.removeEventListener("resize", check);
    }, []);
    return isMobile;
}

export function SubscribeHeader() {
    const { logoUrl } = useBranding();
    const name: string = useQueryParam("name", "") ?? "";
    const { i18n: i18next, t } = useTranslation();
    const currentLang = i18next.language.startsWith("es") ? "es" : "en";
    const isMobile = useIsMobile();

    return (
        <div className="subscribe-header">
            <img src={logoUrl} alt="Brand Logo" className="subscribe-logo" />
            <h2 className="subscribe-greeting">
                {isMobile ? (
                    <>
                        {t("Hey")}
                        {name && name.length > 0
                            ? `, ${capitalizeFirstLetter(name)} `
                            : ","}
                        <FontAwesomeIcon
                            icon={faCircleUser}
                            className="user-icon"
                        />
                        <div
                            style={{
                                width: "2px",
                                height: "24px",
                                background: "#e7e7e7",
                                display: "inline-block",
                                verticalAlign: "middle",
                                borderRadius: "16px",
                            }}
                        />
                        <Dropdown>
                            <Dropdown.Toggle
                                id="lang-flag-toggle"
                                style={{
                                    background: "none",
                                    border: "none",
                                    boxShadow: "none",
                                    padding: 0,
                                    top: "40px !important",
                                }}
                            >
                                <img
                                    src={flagMap[currentLang]}
                                    alt={
                                        currentLang === "en"
                                            ? t("English")
                                            : t("Spanish")
                                    }
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        marginLeft: "8px",
                                    }}
                                />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                popperConfig={{
                                    modifiers: [
                                        {
                                            name: "offset",
                                            options: {
                                                offset: [0, 4],
                                            },
                                        },
                                    ],
                                }}
                            >
                                <Dropdown.Item
                                    onClick={() => i18n.changeLanguage("en")}
                                    active={currentLang === "en"}
                                >
                                    <img
                                        src={flagMap.en}
                                        alt={t("English")}
                                        style={{
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            marginRight: "8px",
                                            objectFit: "cover",
                                        }}
                                    />
                                    {t("English")}
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => i18n.changeLanguage("es")}
                                    active={currentLang === "es"}
                                >
                                    <img
                                        src={flagMap.es}
                                        alt={t("Spanish")}
                                        style={{
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            marginRight: "8px",
                                            objectFit: "cover",
                                        }}
                                    />
                                    {t("Spanish")}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </>
                ) : (
                    <>
                        <Dropdown>
                            <Dropdown.Toggle
                                id="lang-flag-toggle"
                                style={{
                                    background: "none",
                                    border: "none",
                                    boxShadow: "none",
                                    padding: 0,
                                }}
                            >
                                <img
                                    src={flagMap[currentLang]}
                                    alt={
                                        currentLang === "en"
                                            ? t("English")
                                            : t("Spanish")
                                    }
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                    }}
                                />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                popperConfig={{
                                    modifiers: [
                                        {
                                            name: "offset",
                                            options: {
                                                offset: [0, 8],
                                            },
                                        },
                                    ],
                                }}
                            >
                                <Dropdown.Item
                                    onClick={() => i18n.changeLanguage("en")}
                                    active={currentLang === "en"}
                                >
                                    <img
                                        src={flagMap.en}
                                        alt={t("English")}
                                        style={{
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            marginRight: "8px",
                                            objectFit: "cover",
                                        }}
                                    />
                                    {t("English")}
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => i18n.changeLanguage("es")}
                                    active={currentLang === "es"}
                                >
                                    <img
                                        src={flagMap.es}
                                        alt={t("Spanish")}
                                        style={{
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            marginRight: "8px",
                                            objectFit: "cover",
                                        }}
                                    />
                                    {t("Spanish")}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <div
                            style={{
                                width: "2px",
                                height: "32px",
                                background: "#e7e7e7",
                                marginLeft: "24px",
                                display: "inline-block",
                                verticalAlign: "middle",
                                borderRadius: "16px",
                            }}
                        />
                        <FontAwesomeIcon
                            icon={faCircleUser}
                            className="user-icon"
                        />
                        {t("Hey")}
                        {name && name.length > 0
                            ? `, ${capitalizeFirstLetter(name)} `
                            : ","}
                    </>
                )}
            </h2>
        </div>
    );
}
